import { useState } from 'react';
import { FileSpreadsheet, Loader2 } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { downloadOperationsWorkbook } from './exportWorkbook';
import { fetchOperationsExport } from './hooks/useOperations';

export function ExportOperationsButton({ from, to }: { from: string; to: string }) {
    const { user } = useAuth();
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);

    async function exportPeriod() {
        if (!user?.id) {
            setError('Sesión no válida.');
            return;
        }
        setBusy(true);
        setError(null);
        try {
            const data = await fetchOperationsExport(user.id, from, to);
            downloadOperationsWorkbook(data, from, to);
        } catch (err) {
            const message = err instanceof Error ? err.message : 'No se pudo exportar';
            const missingApi = /does not exist|no existe|404|funci[oó]n/i.test(message);
            setError(missingApi ? `${message}. Hace falta desplegar la API de operaciones.` : message);
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="flex flex-col gap-1">
            <button
                type="button"
                disabled={busy}
                onClick={() => void exportPeriod()}
                className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium bg-primary text-primary-foreground disabled:opacity-50"
            >
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSpreadsheet className="h-4 w-4" />}
                Exportar Excel
            </button>
            {error && <p className="text-xs text-destructive max-w-xs">{error}</p>}
        </div>
    );
}
